import { BackspaceOutlined } from '@mui/icons-material';
import { keyboardLineOne, keyboardLineThree, keyboardLineTwo } from './data';
import { Letter } from './Letter';

export const Keyboard = ({
  guess,
  handleLetterClick,
  todaysPlayer,
  guesses,
  todaysCount,
  submitGuess,
  handleDeleteClick,
}) => (
  <>
    <div style={{ textAlign: 'center', paddingTop: '25px', width: '100%' }}>
      {keyboardLineOne.map((letter) => (
        <Letter
          onClick={() => handleLetterClick(letter)}
          value={letter}
          guesses={guesses}
          playerName={todaysPlayer.name}
        />
      ))}
    </div>
    <div style={{ textAlign: 'center', paddingTop: '25px', width: '100%' }}>
      {keyboardLineTwo.map((letter) => (
        <Letter
          onClick={() => handleLetterClick(letter)}
          value={letter}
          guesses={guesses}
          playerName={todaysPlayer.name}
        />
      ))}
    </div>
    <div style={{ textAlign: 'center', paddingTop: '20px', width: '100%' }}>
      <span
        onClick={[...guess].length === todaysCount ? submitGuess : () => {}}
        color={[...guess].length !== todaysCount ? 'blue' : 'grey'}
        style={{ paddingRight: '5px' }}
      >
        ENTER
      </span>
      {keyboardLineThree.map((letter) => (
        <Letter
          onClick={() => handleLetterClick(letter)}
          value={letter}
          guesses={guesses}
          playerName={todaysPlayer.name}
        />
      ))}
      <span onClick={handleDeleteClick} style={{ paddingLeft: '5px' }}>
        <BackspaceOutlined fontSize="inherit" />
      </span>
    </div>
  </>
);
